import { tsrClient } from '@/libs/ts-rest/ts-client';

const useAuthMutations = () => {
	const registerMutation = tsrClient.web.auth.register.useMutation();
	const loginMutation = tsrClient.web.auth.login.useMutation();
	const loginWithProviderMutation = tsrClient.web.auth.loginWithProvider.useMutation();
	const logoutMutation = tsrClient.web.auth.logout.useMutation();
	const forgotPasswordMutation = tsrClient.web.auth.forgotPassword.useMutation();

	return {
		registerMutation,
		loginMutation,
		loginWithProviderMutation,
		logoutMutation,
		forgotPasswordMutation,
	};
};

export default useAuthMutations;